export default {
  LIST: {
    TITLE: `User list`,
    SUMMARY: ``
  },
  CREATE_USER: {
    TITLE: `Create a user`,
    SUMMARY: ``
  },
  EDIT: {
    TITLE: `Modify the user's information`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `View the user's information`,
    SUMMARY: ``
  },
  CREATE: `Create a user`,
  FULLNAME: `Name`,
  FIRST_NAME: `First name`,
  FIRSTNAME: `First name`,
  LAST_NAME: `Last name`,
  LASTNAME: `Last name`,
  PREFERREDPRONOUNS: `Pronouns`,
  LEGALNAME: `Legal name`,
  FIRST_COLUMN: ``,
  CREATED_ON: `Created on`,
  BILLABLE_THIS_MONTH: `Billed`,
  LAST_MODIFIED_ON: `Last updated on`,
  LAST_CONNECTION: `Last connection`,
  BIRTH_DATE: `Birth date`,
  LANGUAGE: `Language`,
  ONBOARDING: `Onboarding`,
  EMPLOYEE_NUMBER: `Employee number`,
  EMPLOYEENUMBER: `Employee number`,
  EMPLOYEE_ID: `Employee id`,
  EMPLOYEEID: `Employee id`,
  USERNAME: `Username`,
  ARCHIVED: `Archived`,
  STATUS: `Status`,
  HIRING_DATE: `Hiring date`,
  HIRINGDATE: `Hiring date`,
  SENIORITY_DATE: `Seniority date`,
  SENIORITYDATE: `Seniority date`,
  OCCUPATIONS: `Occupations`,
  HIRING_DATA: `Hiring data`,
  HIRINGDATA: `Hiring data`,
  PRIORITY_NUMBER: `Priority number`,
  PRIORITYNUMBER: `Priority number`,
  GROUPS: `Permissions`,
  POSITIONS: `Positions`,
  DEPARTMENTS: `Departments`,
  ATTRIBUTES: `Attributes`,
  CLIENTSENIORITIES: `Client based seniority`,
  POSITIONSENIORITIES: `Position based seniority`,
  START_DATE: `Start date`,
  STARTDATE: `Start date`,
  TERMINATION_DATE: `Termination date`,
  TERMINATIONDATE: `Termination date`,
  REGIONAL_TAGS: `Regions`,
  REGIONALTAGS: `Regions`,
  TEAMS: `Teams`,
  PROJECTS: `Projects`,
  PROJECT_RESTRICTIONS: `Project restrictions`,
  SPECIFIC_RESTRICTIONS: `Specific restrictions`,
  VACATION_MINUTES: `Vacation bank`,
  VACATIONMINUTESBANKED: `Vacation bank`,
  ADDRESS: `Address`,
  PAY: `Pay`,
  EMAILS: `Emails`,
  PHONES: `Phones`,
  PHONENUMBERS: `Phones`,
  NAME: `Name`,
  ENGLISH: `English`,
  FRENCH: `French`,
  MALE: `Male`,
  FEMALE: `Female`,
  OTHER: `Other`,
  ACTIVE: `Active`,
  INACTIVE: `Inactive`,
  TERMINATED: `Terminated`,
  pronouns: {
    HE_HIM: `He/Him`,
    SHE_HER: `She/Her`,
    THEY_THEM: `They/Them`,
    OTHER: `Other ({{ preferredPronounOther }})`,
    OTHER_SIMPLE: `Other`
  },
  SPECIFICRESTRICTIONS: `Specific restrictions`,

  PASSWORD: {
    PLACEHOLDER: `Enter a password`,
    LABEL: `Password`,
    DESCRIPTION: `The password must be at least 8 and at most 64 characters long`
  },
  CONFIRMPASSWORD: {
    LABEL: `Password confirmation`,
    PLACEHOLDER: `Enter the password again`,
    DESCRIPTION: ``
  },
  PIN: {
    PLACEHOLDER: `Enter a phone PIN`,
    LABEL: `Phone NIP`,
    DESCRIPTION: ``
  },
  CONFIRMPIN: {
    LABEL: `Enter the PIN again`,
    PLACEHOLDER: `Phone PIN confirmation`,
    DESCRIPTION: ``
  },
  USER_FROM_INTEGRATION: 'Certain fields are not editable because this user is from an integration',
  PROJECT_BLOCKED: `Project (blocked)`,
  PROJECT_PREFERRED: `Project (preffered)`,
  PROJECT_LOCKED: `Project (locked)`,
  WORK_EMAILS: `Work emails`,
  PERSONAL_EMAILS: `Personal emails`,
  PRIMARY_OCCUPATION: `Primary occupation`,
  SECONDARY_OCCUPATION: `Secondary occupation`,
  EMPLOYEE_TYPE: `Employee type`,
  CONTRACT_TYPE: `Contract`,
  PERMIT_TYPE: `Permit`,
  REPORTS_TO: `Reports to`,
  ONBOARD_SELECTED_USER: `Onboard selected users`,
  BILLABLE: 'Billable this month',
  NOT_BILLABLE: 'Not Billable this month',
  BILLABLE_USERS: `Billable Users`,
  BILLABLE_USERS_WARNING: `Number of billable users in current filter`,
  SELECT_ALL_USERS: `Select all`,
  UNSELECT_ALL_USERS: `Unselect all ({{count}})`,
  PASTE_EMPLOYEE_NUMBERS: {
    TITLE: `Paste employee numbers`,
    SUMMARY: `You can paste a list of employee numbers (one per line or separated by a coma or a space)`
  },
  EMPLOYEENUMBERS: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: `125893 268498 18987 16548
   OR 
123456
268198
652899
`
  },
  INVALID_EMPLOYEE_NUMBERS: `The employee numbers {{invalidNumbers}} are invalid`,
  EXPORT_USERS_CSV: `Export users as CSV`,
  USER_REQUESTED_CHANGES: `One user in the current filter has requested changes.`,
  USER_REQUESTED_CHANGES_other: `{{count}} users in the current filter have requested changes.`,
  NEVER_CONNECTED: `Never`,
  onboarding: {
    SENT: `Sent on {{date}}`,
    DELIVERED: `Delivered on {{date}}`,
    OPENED: `Opened on {{date}}`,
    NOT_INVITED: `Not onboarded`
  },
  form: {
    FIRSTNAME: {
      LABEL: `First name`,
      PLACEHOLDER: `Enter the user's first name`,
      DESCRIPTION: ``
    },
    LASTNAME: {
      LABEL: `Last name`,
      PLACEHOLDER: `Enter the user's last name`,
      DESCRIPTION: ``
    },
    LEGALNAME: {
      LABEL: `Legal name`,
      PLACEHOLDER: `Enter the user's legal name`,
      DESCRIPTION: ``
    },
    PREFERREDPRONOUNS: {
      LABEL: `Pronouns`,
      DESCRIPTION: ``
    },
    PREFERREDPRONOUNOTHER: {
      LABEL: `Specify prounouns`,
      PLACEHOLDER: `Enter a value for other`,
      DESCRIPTION: ``
    },
    BIRTHDATE: {
      LABEL: `Date of birth`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If a date of birth is provided, a 🎂 will appear next to the employee's shift on their birthday. The application will also send them a Happy Birthday push notification.`
    },
    LANGUAGE: {
      LABEL: `Language`,
      DESCRIPTION: `When the user logs in, the application will be displayed with this language. All communications will also be sent following the language selected.`
    },
    EMPLOYEENUMBER: {
      LABEL: `Employee number`,
      PLACEHOLDER: `Enter the user's employee number`,
      DESCRIPTION: `<bold>Last employee number created (for reference only): {{lastEmployeeNumber}}</bold><br>
      The employee will use this to log in to the phone system and the punch portal.`
    },
    EMPLOYEEID: {
      LABEL: `Employee ID`,
      PLACEHOLDER: `Enter the user's employee id`,
      DESCRIPTION: ``
    },
    HIRINGDATE: {
      LABEL: `Hiring date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Can be used to sort the users based on date hired.`
    },
    SENIORITYDATE: {
      LABEL: `Seniority date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Can be used to sort the users based on seniority.`
    },
    PRIORITYNUMBER: {
      LABEL: `Priority number`,
      PLACEHOLDER: `Enter the user's priority number`,
      DESCRIPTION: `Can be used to sort the users based on seniority.`
    },
    STARTDATE: {
      LABEL: `Start date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Day at which the user will start working. They will not be available before this date.`
    },
    TERMINATIONDATE: {
      LABEL: `Termination date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Last working day of the employee. They will not be available after this date.`
    },
    EXPIRATIONDATE: {
      LABEL: `Expiration date`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TEAMS: {
      LABEL: `Teams`,
      DESCRIPTION: ``
    },
    PROJECTS: {
      LABEL: `Projects`,
      DESCRIPTION: ``
    },
    VACATIONMINUTESBANKED: {
      LABEL: `Vacation bank`,
      PLACEHOLDER: `Enter the user's vacation bank amount`,
      DESCRIPTION: ``
    },
    GROUPS: {
      LABEL: `Permissions`,
      DESCRIPTION: `The permissions contained in each selected groups will be addition together to define what the user can do.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      DESCRIPTION: `Position on which the user is eligible to work on.`
    },
    DEPARTMENTS: {
      LABEL: `Departments`,
      DESCRIPTION: ``
    },
    REGIONALTAGS: {
      LABEL: `Regions`,
      DESCRIPTION: `Regions on which the user can work within.`
    },
    USERNAME: {
      LABEL: `Username`,
      PLACEHOLDER: `Enter a username`,
      DESCRIPTION: `The username must be unique.`
    },
    PASSWORD: {
      LABEL: `Password`,
      PLACEHOLDER: `Enter the user's password`,
      DESCRIPTION: ``
    },
    CONFIRMPASSWORD: {
      LABEL: `Password confirmation`,
      PLACEHOLDER: `Enter again the password`,
      DESCRIPTION: ``
    },
    PIN: {
      LABEL: `Phone PIN`,
      PLACEHOLDER: `Enter the user's phone PIN`,
      DESCRIPTION: ``
    },
    CONFIRMPIN: {
      LABEL: `Phone PIN confirmation`,
      PLACEHOLDER: `Enter again the phone PIN`,
      DESCRIPTION: ``
    },
    PAY: {
      TITLE: `Pay`,
      REGULAR: {
        LABEL: `Hourly regular wage`,
        PLACEHOLDER: `Enter the wanted wage`,
        DESCRIPTION: ``
      },
      OVERTIME: {
        LABEL: `Hourly overtime wage`,
        PLACEHOLDER: `Enter the wanted wage`,
        DESCRIPTION: ``
      }
    },
    EMERGENCY_CONTACTS: {
      TITLE: `Emergency contact`,
      SUMMARY: `The emergency contact are for reference, the application will not use them.`,
      NAME: {
        LABEL: `Name`,
        PLACEHOLDER: `Enter the name of the emergency contact`,
        DESCRIPTION: ``
      },
      RELATION: {
        LABEL: `Relation`,
        PLACEHOLDER: `Enter the relation of the emergency contact with the employee`,
        DESCRIPTION: `Describes the relation like mother, father, husband, wife.`
      },
      PHONENUMBER: {
        LABEL: `Phone number`,
        PLACEHOLDER: `Enter the emergency contact phone number`,
        DESCRIPTION: `The phone number to call in case of emergency.`
      }
    },
    PROJECT_RESTRICTION: {
      TITLE: `Project restrictions`,
      CHANGES_MADE_IN_PROJECTS: `Project restrictions statuses (Locked, Preferred, and Blocked) must be added from the project edit page.`,
      BLOCKED: `Blocked:`,
      LOCKED: `Locked:`,
      PREFFERED: `Preferred:`
    },
    SPECIFIC_RESTRICTIONS: {
      TITLE: `Specific Restrictions`,
      SUMMARY: `Specific restrictions is a freeform text field that will be displayed when assigning this employee to the schedule.`,
      NO_SPECIFIC_RESTRICTION: `No specific restrictions`,
      ADD_RESTRICTION: `Add a restriction`,
      PLACEHOLDER: `Add a specific restriction to this user.`,
      ADD: `Add`
    },
    OCCUPATIONS: {
      TITLE: `Occupations`,
      PRIMARY: {
        LABEL: `Primary`,
        DESCRIPTION: ``
      },
      SECONDARY: {
        LABEL: `Secondary`,
        DESCRIPTION: ``
      }
    },
    HIRING_DATA_DESCRIPTION: ``,
    HIRINGDATANAME: {
      LABEL: `Select the hiring data`,
      DESCRIPTION: ``
    },
    HIRINGDATASTART: {
      LABEL: `Start`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    HIRINGDATAEND: {
      LABEL: `End`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    NO_EMAILS: `No email address`,
    NO_PHONE_NUMBERS: `No phone number`,
    PERSONNAL_INFO_SECTION: `Personnal information`,
    HIRING_DATA_SECTION: `Hiring information`,
    CONTACT_INFO_SECTION: `Contact information`,
    LOGIN_INFO_SECTION: `Login information`,
    FIELD_MANDATORY: `This field is mandatory.`,
    EXPIRATION_DATE_REQUIRED: 'An expiration date is required',
    USERNAME_CANT_BE_COMPANY: `A username cannot be the name of the company`,
    PERMISSIONS_REQUIRED: `You must add at least one permission group to this user.`,
    USER_ARCHIVED_WARNING: `This user is archived, they will not have access to Merinio.`,
    USER_REQUESTED_CHANGES: `This user requested the following changes, update and save the user to erase this message.`,
    USER_CANT_BE_INVITED: `This user won't receive an onboarding invitation because no email or phone number is provided.`,
    NO_OWN_PROJECT_OR_TEAM: `This user won't be visible anymore once saved as none of your projects or teams is selected.`,
    FAIL_TO_CREATE_USERS: `User creation failed with errors. Please contact support.`,
    EMPLOYEE_ADDED_WITH_ERRORS: `Some users were added but not all.`,
    TEAM_OR_PROJECT_REQUIRED: `L'utilisateur doit être assigné à une équipe ou un projet.`,
    ALREADY_IN_USE: {
      USERNAME: `Username is already in use.`,
      EMPLOYEE_NUMBER: `Employee number is already in use.`,
      EMPLOYEE_ID: `Employee ID already in use.`
    },
    CLIENTSENIORITIES: {
      TITLE: `Client based seniority`,
      DESCRIPTION: `Allows setting a client specific seniority in addition to the general seniority`,
      CLIENTID: {
        LABEL: `Client`,
        DESCRIPTION: ``
      },
      SENIORITYDATE: {
        LABEL: `Seniority date`,
        DESCRIPTION: ``
      }
    },
    POSITIONSENIORITIES: {
      TITLE: `Position based seniority`,
      DESCRIPTION: `Allows setting a position specific seniority in addition to the general seniority`,
      POSITIONID: {
        LABEL: `Position`,
        DESCRIPTION: ``
      },
      SENIORITYDATE: {
        LABEL: `Seniority date`,
        DESCRIPTION: ``
      }
    },
    DUPLICATE_PHONE_NUMBER: `This phone number is duplicated.`,
    DUPLICATE_EMAIL_ADDRESS: `This email address is duplicated.`
  },
  archiveModal: {
    TITLE: `Archive employee {{fullName}}`,
    SUMMARY: `Are you sure you want to archive this employee?`,
    SHIFTS: `Shifts (will be unassigned): {{count}}`,
    TEMPLATEEVENTS: `Templates (will be unassigned): {{count}}`,
    TEAMS: `Teams that report to them (will be unassigned): {{count}}`,
    PROJECTOWNERS: `Projects they manage (will be unassigned): {{count}}`,
    ERROR_ARCHIVING: `There was an error while archiving the user`,
    ARCHIVE_USER: `Archive {{fullName}}`
  },
  unarchiveUsersModal: {
    TITLE: `Unarchive employees`,
    SUMMARY: ``
  },
  archiveUsersModal: {
    TITLE: `Archive employees`,
    SUMMARY: `Are you sure you want to archive these employees?`,
    LOST_SUMMARY: `The following information will be deleted/unassigned if the user is archived:`,
    WILL_BE_IMPACTED: `<h6>This action will have the following consequences (resources unassigned).</h6><h6>To confirm you understand, please check all below:</h6>`,
    SHIFTS: `Shifts (will be unassigned)`,
    TEMPLATEEVENTS: `Templates (will be unassigned)`,
    TEAMS: `Teams that report to them (will be unassigned)`,
    PROJECTOWNERS: `Projects they manage (will be unassigned)`,
    BAD_MATCH: `The input doesn't match "ARCHIVE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    CONFIRM: {
      LABEL: `Type "ARCHIVE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      WORD: `archive`
    },
    CONFIRMAMOUNT: {
      LABEL: `Confirm number of users you are archiving`,
      PLACEHOLDER: `Please enter the number of users`,
      DESCRIPTION: ``,
      CONFIRMAMOUNT_IS_REQUIRED: `Amount is required`,
      BAD_CONFIRMAMOUNT_CONFIRMATION: `Amount is incorrect`
    },
    ARCHIVE_SUBMIT: `Archive {{ count }} user`,
    ARCHIVE_SUBMIT_other: `Archive {{ count }} users`
  },
  DELETE_USER: `Delete user`,
  deleteModal: {
    TITLE: `Delete permanently the employee {{fullName}}`,
    SUMMARY: `Are you sure you want to delete this employee?`,
    SHIFTS: `Shifts (will be unassigned): {{count}}`,
    TEMPLATEEVENTS: `Templates (will be unassigned): {{count}}`,
    LEAVES: `Absence / Lateness / Early out: {{count}}`,
    VACATIONS: `Time off: {{count}}`,
    DISPONIBILITIES: `Availabilities: {{count}}`,
    CONTACTLISTENTRIES: `Contact list entries: {{count}}`,
    LOGS: `Logs: {{count}}`,
    TEAMS: `Teams that report to them (will be unassigned): {{count}}`,
    PROJECTOWNERS: `Projects they manage (will be unassigned): {{count}}`,
    BAD_MATCH: `The input doesn't match "DELETE FOREVER"`,
    FIELD_IS_REQUIRED: `This field is required`,
    DELETE_USER: `Delete {{fullName}}`,
    CONFIRM: {
      LABEL: `Type "DELETE FOREVER" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      WORD: `delete forever`
    }
  },
  onboardingModal: {
    TITLE: `Onboard {{user}}`,
    TITLE_VAR: `selected users`,
    LABEL: `Onboarding message:`,
    SUMMARY: ``,
    INVITE_SUBMIT: `Invite this user`,
    INVITE_SUBMIT_other: `Invite {{ count }} users`,
    EXAMPLE: `Hello [first name of the employee],{{message}}

<1>{{onboardingMessage}}</1>

Your username: [username of the employee]
Your employee number: [employee number (e.g:123456)]`,
    EXAMPLE_SINGLE_USER: `Hello {{user}},{{message}}

<1>{{onboardingMessage}}</1>

Your username: {{username}}
Your employee number: {{employeeNumber}}`,
    EXAMPLE_DEFAUT_MESSAGE: `

{{companyNameEn}} has invited you to join Merinio, an app to see your schedule, accept shifts and submit time-off requests.`,
    YOUR_MESSAGE_HERE: `Your message here.`,
    ONBOARDINGMESSAGE: {
      LABEL: `Your personalized message:`,
      PLACEHOLDER: `Enter a short message`,
      DESCRIPTION: `The onboarding tool allows sending multiple emails to users in order to allow them to connect easily to the application.`
    },
    CONFIRMNUMBERREINVITE: {
      LABEL: `Confirm number of users you are re-inviting`,
      PLACEHOLDER: `Please enter the number of users`,
      DESCRIPTION: ``
    },
    REMOVEDEFAULTMESSAGE: { LABEL: `Remove default message from email`, DESCRIPTION: `` },
    SENDSMSONBOARDING: { LABEL: `Also send onboarding by sms`, DESCRIPTION: `` },
    REINVITEUSERS: { LABEL: `Re-invite previously onboarded users`, DESCRIPTION: `` },
    SEND: `Send invitation`,
    SEND_TEST: `Send me a test message`,
    successNotif: {
      TITLE: `Onboarding sent!`,
      DESCRIPTION: ``
    }
  },
  bulkEdit: {
    TITLE: `Bulk Edit`,
    SUMMARY: `The resources selected will be applied to the following users:`,
    SELECT_STATUS: `Select a status to assign`,
    SELECT_TEAMS: `Select the teams to assign`,
    SELECT_PROJECTS: `Select the projects to assign`,
    SELECT_RESTRICTIONS: `Select the restrictions to assign`,
    SELECT_SKILLS: `Select the skills to assign`,
    SELECT_REQUIREMENTS: `Select the requirements to assign`,
    SELECT_ALERTS: `Select the alerts to assign`,
    SELECT_DEPARTMENTS: `Select the departments to assign`,
    SELECT_HIRINGDATA: `Select the hiring data to assign`,
    SELECT_REGIONALTAGS: `Select the regions to assign`,
    SELECT_PERMISSIONS: `Select the permissions to assign`,
    SELECT_POSITIONS: `Select the positions to assign`,
    SELECT_PAY: `Select pay type and amount to set`,
    SELECT_REGIONS: `Select regions to assign`,
    STATUS: `Status`,
    TEAMS: `Teams`,
    PROJECTS: `Projects`,
    SKILLS: `Skills`,
    RESTRICTIONS: `Restrictions`,
    REQUIREMENTS: `Requirements`,
    ALERTS: `Alerts`,
    DEPARTMENTS: `Departments`,
    HIRINGDATA: `Hiring data`,
    ATTRIBUTES: `Attributes`,
    REGIONS: `Regions`,
    REGIONALTAGS: `Regions`,
    PERMISSIONS: `Permissions`,
    POSITIONS: `Positions`,
    PAY: `Pay`,
    APPLY: `Apply`,
    ASSIGN: `Assign`,
    UNASSIGN: `Unassign`,
    DONE: `Done`,
    TYPE: { LABEL: 'Type', DESCRIPTION: 'Select the type of bulk edit to apply the the selected users' },
    OPTIONS: {
      ACTIVE: `Active`,
      INACTIVE: `Inactive`,
      TERMINATED: `Terminated`
    },
    HIRING_DATA_START: {
      LABEL: `Start`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    HIRING_DATA_END: {
      LABEL: `End`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYTYPE: {
      LABEL: ``,
      OPTIONS: {
        REGULAR: {
          LABEL: `Regular`,
          DESCRIPTION: ``
        },
        OVERTIME: {
          LABEL: `Overtime`,
          DESCRIPTION: ``
        }
      }
    },
    PAYAMOUNT: {
      LABEL: `Amount`,
      DESCRIPTION: `Must be a decimal amount in dollars.`,
      PLACEHOLDER: ``
    },
    SEARCH: {
      LABEL: ``,
      PLACEHOLDER: `Search here`,
      DESCRIPTION: ``
    }
  },
  MUST_SELECT_ONE: `You must select at least one resource.`,
  diffs: {
    TITLE: `Edit history for {{fullName}}`,
    SUMMARY: ``,
    TIMESTAMP: `<1>{{ time }}</1> on {{ date }} by <0>{{ name }}</0>`,
    SIMPLE_FIELD: `{{property}} was changed from <1>{{before}}</1> to <2>{{after}}</2>.`,
    SIMPLE_FIELD_ADDED: `{{property}} was set to <2>{{after}}</2>.`,
    SIMPLE_FIELD_REMOVED: `{{property}} was removed, initially <1>{{before}}</1>.`,
    ADVANCED_FIELD_MODIFICATION: `{{property}} was changed from <1>{{removedElements}}</1> to <2>{{addedElements}}</2>`,
    ADVANCED_FIELD_ALL_REMOVED: `{{property}} was cleared of all values (<1>{{removedElements}}</1>).`,
    ADVANCED_FIELD_ADDED: `{{property}} was set to <2>{{addedElements}}</2>`,
    ADVANCED_FIELD_TODO: `{{property}} was altered. No information available.`,
    INFORMATION_UNAVAILABLE: `Information unavailable`,
    ADDRESS_MODIFIED: `Address was modified.`,
    CLIENTSENIORITIES_MODIFIED: `Client seniorities were modified.`,
    POSITIONSENIORITIES_MODIFIED: `Position seniorities were modified.`,
    EMERGENCYCONTACTS_MODIFIED: `Emergency contacts were modified.`,
    EMAILS_MODIFIED: `Emails were modified.`,
    PHONENUMBERS_MODIFIED: `Phone numbers were modified.`,
    PROJECTS_MODIFIED: `Projects status was modified.`,
    PAY_REGULAR: `Pay (regular)`,
    PAY_OVERTIME: `Pay (overtime)`,
    OCCUPATION_PRIMARY: `Occupation (primary)`,
    OCCUPATION_SECONDARY: `Occupation (secondary)`,
    SEE_MODIFICATIONS: `See modification history`,
    USER_ARCHIVED: `Was archived`,
    USER_UNARCHIVED: `Was unarchived`
  },
  DELETE_TEMPLATE: `Delete template`,
  EDIT_TEMPLATE: {
    TITLE: `Edit a user template`,
    SUMMARY: `User templates allows you to prefill certain fields of the user creation form based on common employee needs.`
  },
  CREATE_TEMPLATE: {
    TITLE: `Create a user template`,
    SUMMARY: `User templates allows you to prefill certain fields of the user creation form based on common employee needs.`
  },
  template: {
    CREATE_NEW_USER: `Create a user`,
    CREATE_USER_WITH: `Create a user from <0>{{name}}</0>`,
    CREATE_NEW_TEMPLATE: `Create a new user template`,
    MANAGE_TEMPLATES: `Manage user templates`,
    EDIT_TEMPLATE: `Edit user template <0>{{name}}</0>`,
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the name`,
      DESCRIPTION: `The name will be used to recognize the user template when selecting which one to create a user based on.`
    }
  },
  sync: {
    TITLE: `Sync users`,
    SUMMARY: ``,
    MOST_RECENT_FILE: `Most recent transfer: {{date}}`,
    REFRESH_STATUS: `Refresh status`,
    IMPORT_SELECTED_USERS: `Import selected users`
  },
  import: {
    TITLE: {
      TITLE: `Import users`,
      SUMMARY: ``
    },
    IMPORT_USERS: `Import users`,
    MANDATORY_FIELDS: `Required fields instructions`,
    OPTIONAL_FIELDS: `Optional fields instructions`,
    OPTIONS: `Import options`,
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    USERS_SAVING_FAILED: `There was <0>{{count}}</0> user that were not saved.`,
    USERS_SAVING_FAILED_other: `There was <0>{{count}}</0> users that were not saved.`,
    USERS_NOT_VALID: `There was <0>{{count}}</0> invalid user.`,
    USERS_NOT_VALID_other: `There was <0>{{count}}</0> invalid users.`,
    TEMPLATE_FILE_NAME: `template_users`,
    DOWNLOAD_TEMPLATE: `Download template`,
    FIRSTNAME_DESC: `Employee's given name, minimum of <0>2</0> characters.`,
    LASTNAME_DESC: `Employee's surname, minimum of <0>2</0> characters.`,
    EMPLOYEENUMBER_DESC: `Employee numbers must be both unique and numerical to be valid.`,
    LANGUAGE_DESC: `Valid entries are <1>fr</1> for French and <1>en</1> for English.`,
    STATUSID_DESC: `Valid entries are <1>A </1>for active and <1>I</1> for inactive.`,
    USERNAME_DESC: `Usernames must be unique to be valid. By default, if no username is provided, the <0>employeeNumber</0> will be saved as username.`,
    PERMISSIONS_DESC: `To enter more than one value leave a space between each code.`,
    ATTRIBUTES_DESC: `Must be in the format <1>importCode:Rank:YYYY-MM-DD</1>, where an attribute with import code <1>ABC</1>, rank <1>1</1> and expiration date <1>2020-08-02</1> would be imported as <1>ABC:1:2020-08-02</1>. It must be an import code and a rank as chosen by your administrator. If no rank is provided (for instance <1>ABC</1>), the default rank of 1 will be set. The expiration date is needed only for the attributes that require it. To enter more than one attribute, leave a space between each code, for example: <1>ABC:1:2020-08-02</1> <1>DCE:2:2020-05-01</1>`,
    CLIENTSENIORITIES_DESC: `Must be in the format <1>importCode:YYYY-MM-DD</1>, where a client with import code <1>ABC</1> and seniority date <1>2010-05-20</1> would be imported as <1>ABC:2010-05-20</1>. It must be an import code as chosen by your administrator. To enter more than one client seniority, leave a space between each code, for example: <1>ABC:2010-05-20</1> <1>DCE:2015-03-12</1>`,
    POSITIONSENIORITIES_DESC: `Must be in the format <1>importCode:YYYY-MM-DD</1>, where a position with import code <1>ABC</1> and seniority date <1>2010-05-20</1> would be imported as <1>ABC:2010-05-20</1>. It must be an import code as chosen by your administrator. To enter more than one position seniority, leave a space between each code, for example: <1>ABC:2010-05-20</1> <1>DCE:2015-03-12</1>`,
    HIRINGDATE_DESC: `Must be in the format <1>YYYY-MM-DD</1>`,
    BIRTHDATE_DESC: `Must be in the format <1>YYYY-MM-DD</1>`,
    PRIORITYNUMBER_DESC: `Priority numbers must be numerical values.`,
    EMPLOYEEID_DESC: `EmployeeIds can be any alphanumerical value.`,
    PERSONALEMAIL_DESC: `Use to add '<0>Personal</0>' type email addresses.`,
    WORKEMAIL_DESC: `Use to add '<0>Work</0>' type email addresses.`,
    HOMEPHONE_DESC: `Use to add '<0>Home/Call</0>' type phone numbers. Must be a valid phone number in the format <1>XXX-XXX-XXXX</1> or <1>XXXXXXXXXX</1>.`,
    CELLPHONE_DESC: `Use to add '<0>Mobile/Call</0>' type phone numbers. Must be a valid phone number in the format <1>XXX-XXX-XXXX</1> or <1>XXXXXXXXXX</1>`,
    PASSWORD_DESC: `Password must be between <0>8</0> and <0>12</0> alpha-numerical caracters`,
    PHONEPASSWORD_DESC: `Phone passwords must be numerical, between <0>4</0> and <0>8</0> characters.`,
    VACATIONMINUTESBANKED_DESC: `Use to set the vacation bank of the user. Must be in minutes, for 3 weeks it would be (3*5*8*60) <1>7200</1>.`,
    PAYREGULAR_DESC: `Use to set regular hourly wage. Must be an amount in dollars.`,
    PAYOVERTIME_DESC: `Use to set overtime hourly wage. Must be an amount in dollars.`,
    DEPARTMENTS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    PRIMARYOCCUPATION_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    SECONDARYOCCUPATION_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    POSITIONS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    PROJECTS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    CONTRACTTYPES_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    PERMITTYPES_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    EMPLOYEETYPES_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    TEAMS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    REGIONALTAGS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    LEGALNAME_DESC: `Employee legal name`,
    PREFERREDPRONOUNS_DESC: `Employee's pronouns (The predefined choices are <1>SHE_HER</1>, <1>HE_HIM</1> or <1>THEY_THEM</1>. A custom value can be given and will be considered as <1>OTHER</1>)`,
    EMERGENCYCONTACTS_DESC: `Must be in the format <1>(name:relation:XXX-XXX-XXXX)</1> or <1>(name:relation:XXXXXXXXXX)</1>, where an emergency contact with name <1>John Doe</1>, relation <1>Father</1> and phone number <1>514-526-5879</1> would be imported as <1>(John Doe:Father:514-526-5879)</1>. You can enter more than one emergency contact, for example: <1>(John Doe:Father:514-526-5879)</1><1>(Sandy Doe:Mother:514-358-9875)</1>`,
    FULLNAME: `Fullname`,
    EMPLOYEE_NUMBER: `Employee number`,
    LANGUAGE: `Language`,
    USERNAME: `Username`,
    PERMISSIONS: `Permissions`,
    HIRING_DATE: `Hiring date`,
    BIRTH_DATE: `Birth date`,
    PRIORITY_NUMBER: `Priority number`,
    EMPLOYEE_ID: `Employee ID`,
    PERSONALEMAIL: `Personal email`,
    WORKEMAIL: `Work email`,
    HOMEPHONE: `Home phone`,
    CELLPHONE: `Cell phone`,
    PASSWORD: `Password`,
    PHONE_PASSWORD: `PIN`,
    VACATION_MINUTES_BANKED: `Vacation bank`,
    DEPARTMENTS: `Departments`,
    PRIMARY_OCCUPATION: `Primary occupation`,
    SECONDARY_OCCUPATION: `Secondary occupation`,
    POSITIONS: `Positions`,
    CONTRACT: `Contract`,
    EMPLOYEE_TYPE: `Employee type`,
    ATTRIBUTES: `Attributes`,
    PROJECTS: 'Projects',
    PERMIT: `Permit`,
    TEAMS: `Teams`,
    UPDATE: `Update`,
    REGIONAL_TAGS: `Regions`,
    CLIENTSENIORITIES: `Client based seniority`,
    POSITIONSENIORITIES: `Position based seniority`,
    PAY_REGULAR: `Regular hourly wage`,
    PAY_OVERTIME: `Overtime hourly wage`,
    ERROR_READING_CSV: `The file that was uploaded does not respect the proper CSV format, if your excel is in french, please change your delimiter settings.`,
    IGNORE_INACTIVE: `Ignore inactive users`,
    IGNORE_ARCHIVED: `Ignore archived users`,
    CONCAT_ARRAYS: `Do not erase existing values for fields with multiple values`,
    LEGALNAME: `Legal name`,
    PREFERREDPRONOUNS: `Pronouns`,
    EMERGENCYCONTACTS: `Emergency contacts`
  },
  EMERGENCY_CONTACTS: `Emergency contact`,
  SEE_COMPUTED_PERMISSIONS: `See computed permissions`,
  SEE_COMMENTS: `See comments/notes`,
  SEE_ATTACHMENTS: `See attachments`,
  SEE_ATTRIBUTES_REMINDERS_HISTORY: `See attributes expiration reminders history`,
  SEE_REQUESTS_SUMMARY: `See requests summary`,
  SEE_SCHEDULE: `See employee schedule`,
  MODIFY_PASSWORD: `Change password`,
  SEND_RESET: `Send password reset link`,
  RESET_SENT: `Password reset link has been sent`,
  MODIFY_PIN: `Change phone PIN`,
  MODIFY_USERNAME: `Change username`,
  CHANGE_PASSWORD_MODAL: {
    TITLE: `Password modification`,
    SUMMARY: ``
  },
  CHANGE_PIN_MODAL: {
    TITLE: `Phone PIN modification`,
    SUMMARY: ``
  },
  CHANGE_USERNAME: {
    TITLE: `Username modification`,
    SUMMARY: ``
  },
  ATTRIBUTE_EXPIRATION_REMINDERS_MODAL: {
    TITLE: 'Attributes expiration reminders history for {{name}}',
    SUMMARY: '',
    CONFIRMED: `Confirmation by <0>{{name}}</0> at <0>{{ time }}</0> on <0>{{ date }}</0>.`,
    DELIVERED: `Reminder for the attribute <0>{{attribute}}</0> delivered at <0>{{ time }}</0>  on <0>{{ date }}</0>.`,
    EVENT_CONFIRMED: 'Confirmed',
    EVENT_DELIVERED: 'Delivered',
    NO_REMINDERS: 'No reminders have been sent yet'
  },
  seeComputedPermisionsModal: {
    TITLE: `Permissions`,
    SUMMARY: `Lets you see all the permissions a user has. A user has the combined permissions of all groups they belong to.`
  },
  REPORT_NAME: `users_export`
}
